export interface StreetViewState {
  position?: StreetViewPosition;
  pov: StreetViewPov;
}

export interface StreetViewPosition {
  lat: number;
  lng: number;
}

export interface StreetViewPov {
  pitch: number;
  heading: number;
}

export const defaultStreetViewState = (): StreetViewState => ({
  position: undefined,
  pov: {
    pitch: 0,
    heading: 0,
  },
});
